import React, { useMemo } from 'react';
import GetState from '../GetState';
import useMetronome from '../utility/useMetronome';
import { QuestRoute } from '../api/QuestRoutes';
import { generateId, shortHandDateTime } from '../utility/functions';
import Table from '../table/Table';
import RoleProtected, { IsAuthorized, userRoles } from '../RoleProtected';
import { toRow } from '../pages/reporting/subscription/ClubShield';
import { renderCustomerLink } from '../pages/plateReads/LicensePlateReads';

const ClubShield = ({ ...props }) => {
    const canView = IsAuthorized(userRoles.viewCustomers);
    const [data, refreshData] = GetState(canView ? QuestRoute.plateReads.clubShield : null);

    useMetronome(() => canView && refreshData(), 60000);

    const rows = useMemo(() => data instanceof Array ? data.map(toRow) : data, [data]);

    return (
        <RoleProtected roles={userRoles.viewCustomers}>
            <div style={{ height: '100%' }}>
                <Table
                    config={{
                        disableHeaderSearch: true,
                        disableTableControls: true,
                        disableMobileView: true,
                        data: rows,
                        headers: [
                            {
                                label: 'Customer',
                                propKey: 'customerName',
                            }, {
                                label: 'Alerts',
                                propKey: 'alertCount',
                            }, {
                                label: 'Type',
                                propKey: 'alertsText',
                            }, {
                                label: 'Last Alert',
                                propKey: 'lastAlertDate',
                            }
                        ],
                        renderFormat: (e) => (
                            <tr key={generateId()}>
                                <td>{renderCustomerLink(e, true)}</td>
                                <td>{e.alertCount}</td>
                                <td>{e.alertsText}</td>
                                <td>{shortHandDateTime(e.lastAlertDate)}</td>
                            </tr>
                        )
                    }}
                />
            </div>
        </RoleProtected>
    );
}

export default ClubShield;
